import { Controller } from "@hotwired/stimulus";
import { interpolate } from "../../utils/string_utils";
import { getFilterLabel } from "../../datatables/datatable_filters";

export default class extends Controller {
  static targets = ["content"];

  displayContent(content) {
    const name = this.element.dataset.filterName;
    const templateContent = interpolate(document.getElementById("selected-filter-preview-content-template"), {
      filter_name: name,
      translated_filter_value: content,
      filter_label: getFilterLabel(name),
    });

    this.contentTarget.innerHTML = templateContent;
  }
}
